import {
  LOADING_COMPANYLIST,
  LOADING_COMPANY_HISTORY,
  LOADING_COMPANY_AUDIT,
  LOADING_COMPANY_SETTINGS,
  COMPANY_LIST_LOADED,
  COMPANY_SELECTED,
  AGREEMENT_SELECTED,
  AGREEMENT_LIST_LOADED,
  LOADING_AGREEMENTLIST,
  COMPANY_VALIDATED,
  COMPANY_DETAILS_LOADED,
  SETUP_COMPANY_LIST_LOADED,
  SELECTED_COMPANY_UPDATED,
  BACK_TO_COMPANIES,
  COMPANY_DETAILS_USERS_UPDATED,
  COMPANY_SYNC_LOADING,
  UNSYNCED_LIST_LOADED,
  ADD_TOAST,
  DISMISS_TOAST,
  COMPANY_HISTORY_LOADED,
  COMPANY_AUDIT_LOADED,
  COMPANY_SETTINGS_LOADED,
  USER_UPDATE_SUCCESS,
  USER_EXCLUDE_SUCCESS,
  USER_SELECTED,
} from '../components/actions/companyTypes'

import produce from 'immer'

const initialState = {
  loading: true,
  loadingHistory: false,
  loadingAudit: false,
  loadingSettings: false,
  syncLoading: false,
  createCompanyList: [],
  createSelected: null,
  companyAgreementList: [],
  selectedAgreement: null,
  selectedCompany: null,
  displayedCompanyUsers: null,
  displayedCompanyUsersCount: 0,
  selectedCompanyUsers: null,
  selectedCompanyExcludedAdditions: null,
  selectedCompanyName: null,
  selectedCompanyAudit: null,
  selectedCompanyHistory: null,
  setupCompanyList: [],
  unsyncedList: [],
  toasts: [],
}

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_COMPANYLIST:
      state.loading = true
      return state
    case LOADING_COMPANY_HISTORY:
      state.loadingHistory = true
      return state
    case LOADING_COMPANY_AUDIT:
      state.loadingAudit = true
      return state
    case LOADING_COMPANY_SETTINGS:
      state.loadingSettings = true
      return state
    case LOADING_AGREEMENTLIST:
      state.loading = true
      return state
    case UNSYNCED_LIST_LOADED:
      state.loading = false
      state.unsyncedList = action.payload
      return state
    case COMPANY_LIST_LOADED:
      state.loading = false
      state.createCompanyList = action.payload
      return state
    case COMPANY_SELECTED:
      state.createSelected = action.payload
      return state
    case AGREEMENT_SELECTED:
      state.selectedAgreement = action.payload
      return state
    case AGREEMENT_LIST_LOADED:
      state.loading = false
      state.companyAgreementList = action.payload
      return state
    case SETUP_COMPANY_LIST_LOADED:
      state.loading = false
      state.setupCompanyList = action.payload
      if (state.selectedCompany) {
        try {
          state.selectedCompany = state.setupCompanyList.find((c) => c.id === state.selectedCompany.id)
        } catch {
          state.selectedCompany = null
          state.displayedCompanyUsers = null
          state.selectedCompanyExcludedAdditions = null
        }
      }
      return state

    case USER_EXCLUDE_SUCCESS:
      state.loading = false
      return produce(state, (draftState) => {
        let user = state.displayedCompanyUsers.find((c) => c.id === action.payload.rowId)
        user.excludedFromAgreement = action.payload.newValue.excluded
        user.selectedExcludedAdditions = action.payload.newValue.selectedValue
      })
    case USER_UPDATE_SUCCESS:
      state.loading = false
      return produce(state, (draftState) => {
        let user = state.displayedCompanyUsers.find((c) => c.id === action.payload.rowId)
        user.invoiceStatus = action.payload.newValue.selectedValue.value
        if (action.payload.newValue.selectedDate !== null && action.payload.newValue.selectedDate !== undefined) {
          user.ignoredUntil = action.payload.newValue.selectedDate
        }
      })
    case USER_SELECTED:
      return state;
    case COMPANY_VALIDATED:
      state.loading = false
      state.newCompanyValidated = true
      state.newCompanyUserCount = action.payload
      state.newCompanyLabel = state.createSelected
      state.selectedAgreement = null
      state.createSelected = null
      return state
    case COMPANY_DETAILS_LOADED:
      state.displayedCompanyUsersCount = action.payload.userCount
      state.displayedCompanyUsers = action.payload.users
      state.selectedCompanyUsers = [];
      state.selectedCompanyExcludedAdditions = action.payload.excludedAdditions
      state.setupCompanyList = action.payload.companies
      state.selectedCompany = action.payload.companies.find((c) => c.id === action.payload.selectedCompanyId)
      state.loading = false
      return state
    case COMPANY_HISTORY_LOADED:
      state.selectedCompanyHistory = action.payload.history
      state.selectedCompanyHistoryCount = action.payload.historyCount
      state.loadingHistory = false
      return state
    case COMPANY_SETTINGS_LOADED:
      state.selectedCompanySettings = action.payload.settings
      state.loadingSettings = false
      return state
    case COMPANY_AUDIT_LOADED:
      state.selectedCompanyAudit = action.payload.audit
      state.selectedCompanyAuditCount = action.payload.auditCount
      state.loadingAudit = false
      return state
    case COMPANY_DETAILS_USERS_UPDATED:
      state.loading = false
      state.displayedCompanyUsers = action.payload.users
      state.selectedCompanyExcludedAdditions = action.payload.excludedAdditions
      return state
    case SELECTED_COMPANY_UPDATED:
      state.selectedCompany = state.setupCompanyList.find((c) => c.id === action.payload)
      return state
    case BACK_TO_COMPANIES:
      state.selectedCompany = null
      state.displayedCompanyUsers = null
      state.selectedCompanyExcludedAdditions = null
      return state
    case COMPANY_SYNC_LOADING:
      state.syncLoading = !state.syncLoading
      return state
    case ADD_TOAST:
      state.toasts.push(action.payload)
      return state
    case DISMISS_TOAST:
      state.newCompanyValidated = false
      state.newCompanyUserCount = null
      state.newCompanyLabel = null
      return state
    default:
      return state
  }
}

export default companyReducer
